module.exports = __webpack_public_path__ + "64910236f7e11126ff17eded4d54fef9.png";